// extracted by mini-css-extract-plugin
export var container = "_e5-1";
export var cornerButtonContainer = "_e5-6";
export var disabled = "_e5-2";
export var dragActive = "_e5-3";
export var fileContainer = "_e5-5";
export var hiddenInput = "_e5-4";
export var widthContainer = "_e5-0";